module.exports = __webpack_public_path__ + "img/create_order_excel.90f60f27.png";